import { render, staticRenderFns } from "./MobileProduct.vue?vue&type=template&id=d98cd5f0&"
import script from "./MobileProduct.vue?vue&type=script&lang=js&"
export * from "./MobileProduct.vue?vue&type=script&lang=js&"
import style0 from "./MobileProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports